import { RELEASE_APRIL_TAX_SERVICES } from '#client/constants/experimentsFlags';

import { TaxClassificationGate } from '../components/gates/TaxClassificationGate';
import { TaxPartnerExclusivityGate } from '../components/gates/TaxPartnerExclusivityGate';
import { getBuyButtonConfig } from '../utils/commonEntitlements';
import { BUSINESS_FINANCE_TAX_ACCOUNT_PARTNERS, BUSINESS_ENTITY_TAX_CLASSIFICATION } from '../utils/taxUtils';

export const QUARTERLY_TAX_PLANNING_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.quarterlyTaxPlanning.buyBox.bulletPoint1' },
        { title: 'productPage.quarterlyTaxPlanning.buyBox.bulletPoint2' },
        { title: 'productPage.quarterlyTaxPlanning.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.quarterlyTaxPlanning.buyBox.productName',
      interactService: {
        ctaType: 'internalCheckout',
        service: 'zb_quarterly_tax_planning'
      }
    }],
    headerPicture: {
      src: '/s2/raster/happy-woman-talking-on-the-phone.png',
      alt: 'productPage.quarterlyTaxPlanning.heroPicture.altText',
      objectPosition: 'center'
    },
    headline: 'productPage.quarterlyTaxPlanning.page.headline',
    subheader: 'productPage.quarterlyTaxPlanning.page.subheader',
    partnerLogo: { src: '/s2/vector/april-logo-purple.svg', alt: 'April Logo' },
    partnerReviewBlanks: [
      { text: 'productPage.quarterlyTaxPlanning.page.reviewText' },
      { src: '/illustration/trustpilot-4.5-star.svg', showOnMobile: true, alt: '' },
      { src: '/illustration/trustpilot-logo.svg', alt: '' }
    ]
  },
  benefit: {
    title: 'productPage.quarterlyTaxPlanning.whatYouGet.title',
    items: [
      {
        icon: '/s2/material-icons/percentrounded.svg',
        title: 'productPage.quarterlyTaxPlanning.whatYouGet.item1.title',
        description: 'productPage.quarterlyTaxPlanning.whatYouGet.item1.desc'
      },
      {
        icon: '/s2/material-icons/insertinvitationrounded.svg',
        title: 'productPage.quarterlyTaxPlanning.whatYouGet.item2.title',
        description: 'productPage.quarterlyTaxPlanning.whatYouGet.item2.desc'
      },
      {
        icon: '/s2/material-icons/tableviewrounded.svg',
        title: 'productPage.quarterlyTaxPlanning.whatYouGet.item3.title',
        description: 'productPage.quarterlyTaxPlanning.whatYouGet.item3.desc'
      }
    ]
  },
  howItWorks: {
    title: 'productPage.quarterlyTaxPlanning.howItWorks.title',
    items: [
      {
        title: 'productPage.quarterlyTaxPlanning.howItWorks.step1',
        description: 'productPage.quarterlyTaxPlanning.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.quarterlyTaxPlanning.howItWorks.step2',
        description: 'productPage.quarterlyTaxPlanning.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.quarterlyTaxPlanning.howItWorks.step3',
        description: 'productPage.quarterlyTaxPlanning.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/couple-owners-restaurant.png',
    alt: 'productPage.quarterlyTaxPlanning.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  whatsIncluded: {
    title: 'productPage.quarterlyTaxPlanning.whatsIncluded.title',
    items: [
      {
        title: 'productPage.quarterlyTaxPlanning.whatsIncluded.item1',
        description: 'productPage.quarterlyTaxPlanning.whatsIncluded.item1ShortDescription'
      },
      {
        title: 'productPage.quarterlyTaxPlanning.whatsIncluded.item2',
        description: 'productPage.quarterlyTaxPlanning.whatsIncluded.item2ShortDescription'
      }
    ],
    image: '/s2/raster/tax-planning-reminders.png',
    alt: 'productPage.quarterlyTaxPlanning.whatsIncluded.altText',
    hasIcon: true,
    hasNumber: false,
    hasDivider: false,
    hasMobileImage: true
  },
  relatedProducts: {
    title: 'productPage.quarterlyTaxPlanning.relatedProducts.title',
    items: [
      {
        title: 'productPage.quarterlyTaxPlanning.relatedProducts.taxFiling.title',
        description: 'productPage.quarterlyTaxPlanning.relatedProducts.taxFiling.description',
        productSlug: 'tax-filing',
        entitlement: 'zb_tax_full_service_biz_per_llc'
      },
      {
        title: 'dashboard.products.money_pro.title',
        description: 'dashboard.products.money_pro.description',
        productSlug: 'money-pro',
        entitlement: 'money_pro'
      }
    ]
  },
  assistance: {
    title: 'productPage.quarterlyTaxPlanning.needAssistance.title',
    getInTouch: 'productPage.quarterlyTaxPlanning.needAssistance.getInTouch',
    actions: 'productPage.quarterlyTaxPlanning.needAssistance.actions',
    icon: '/s2/material-icons/phonerounded.svg',
    additionalAssistance: [
      {
        icon: '/s2/material-icons/insertinvitationrounded.svg',
        title: 'productPage.quarterlyTaxPlanning.needAssistance.expert.title',
        actions: 'productPage.quarterlyTaxPlanning.needAssistance.expert.cta',
        // TODO: Update this to the actual link, provided by product. This is temporary
        href: 'https://www.zenbusiness.com/contact-us/'
      }
    ]
  },
  // Configure product gates (feature flags, component with custom logic, etc.) useful for conditional redirects
  productGates: {
    flagGate: {
      flagKey: RELEASE_APRIL_TAX_SERVICES,
      redirectPath: '/products/tax-advice'
    },
    componentGates: [{
      Component: TaxPartnerExclusivityGate,
      props: {
        partnerName: BUSINESS_FINANCE_TAX_ACCOUNT_PARTNERS.APRIL,
        redirectPath: '/products/tax-advice'
      }
    }, {
      Component: TaxClassificationGate,
      props: {
        shouldRedirect: (taxClassification) => taxClassification
          !== BUSINESS_ENTITY_TAX_CLASSIFICATION.SINGLE_MEMBER_LLC,
        redirectPath: '/products/tax-advice'
      }
    }]
  },
  getBuyButtonConfig: (entitlements, service) => getBuyButtonConfig({
    entitlements,
    service,
    ctaText: 'productPage.quarterlyTaxPlanning.buyBox.buttonLabel'
  })
};
